<div
  class="host-customer-service-message-item"
  [class.right]="position === 'right'"
  [class.checked]="message.checked"
  [class.small]="size === 'small'">
  <!-- <p class="time">2222-22-22 22:@2:22</p> -->
  <ng-container *ngIf="type === 'label' else chat">
    <div
      class="time"
      [innerHTML]="message?.html | html"></div>
  </ng-container>
  <ng-template #chat>
    <div class="body">
      <label
        *ngIf="checking"
        nz-checkbox
        [(ngModel)]="message.checked"
        class="check-box"></label>
      <img
        class="user-header"
        [src]="message?.user?.photo">
      <div
        class="user-content-wrapper"
        (contextmenu)="onContextMenu($event, menu)">
        <ng-container *ngIf="type === 'text' else image">
          <div class="text">
            <div
              class="content"
              [innerHTML]="message?.html | html"></div>
            <div
              class="content translated"
              *ngIf="displayTranslate">
              {{ message?.message?.translated || ('customer_service.translating' | translate) }}
            </div>
          </div>
        </ng-container>
        <ng-template #image>
          <img
            class="image"
            [src]="message.html"
            (click)="onClickImage(message.html)">
        </ng-template>
        <ng-container *ngIf="message?.errorMsg">
          <img
            src="/assets/dialogue/error_msg.png"
            alt
            class="error-icon">
          <div class="error-msg">{{ message?.errorMsg }}</div>
        </ng-container>
      </div>
    </div>
  </ng-template>
</div>

<nz-dropdown-menu #menu="nzDropdownMenu">
  <ul nz-menu>
    <li
      nz-menu-item
      class="copy-content"
      [attr.data-clipboard-text]="message?.message?.content">
      {{ "word.copy" | translate }}
      <!-- 复制 -->
    </li>
    <li
      nz-menu-item
      (click)="onCheck()">
      {{ "word.multiple_choice" | translate }}
      <!-- 多选 -->
    </li>
  </ul>
</nz-dropdown-menu>
